import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import combineSelectors from 'utils/combineSelectors';
import {
  modelWorkingStateDenormalized,
  inCartQuantity,
  modelSubmittedTotalWorkingStateCalculated,
  totalQuota,
} from 'reducers/models/selectors';
import {
  templatePriority,
  templateQuantity,
} from 'reducers/templates/selectors';
import { theme } from 'reducers/dashboard/selectors';
import { addIntlProps, addProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import { getCurrentUser } from 'utils/localStorage';
import messages from './messages';
import { updateModelWorkingState } from 'reducers/models/actions';
import { workingStateSubmissionLoading } from 'reducers/loading/selectors';
import changeTemplateStatus from 'utils/changeTemplateStatus';
import styles from './styles.module.scss';

export const submitToCart = ({
  modelWorkingStateDenormalized,
  templateId,
  updateModelWorkingState,
}) => () => {
  let currentUser = getCurrentUser();
  const newWorkingState = changeTemplateStatus(
    modelWorkingStateDenormalized,
    templateId,
    'inCart',
    currentUser,
  );
  updateModelWorkingState(newWorkingState);
};

export const remainingQuota = ({
  totalQuota,
  modelSubmittedTotalWorkingStateCalculated,
  inCartQuantity,
}) => totalQuota - modelSubmittedTotalWorkingStateCalculated - inCartQuantity;

export const disabledButton = ({
  remainingQuota,
  isDuplicate,
  templatePriority,
  templateQuantity,
  workingStateSubmissionLoading,
}) =>
  workingStateSubmissionLoading ||
  isDuplicate ||
  templateQuantity > remainingQuota ||
  templatePriority.selectedPriority === 'n/a';

export const buttonStyle = ({ disabledButton }) =>
  disabledButton ? styles.disabled : styles.active;

export const buttonTheming = ({ theme, disabledButton }) =>
  disabledButton
    ? {
        color: theme.button.inactiveText,
        border: theme.button.inactiveBorder,
      }
    : {
        color: theme.button.activeText,
        border: theme.button.activeBorder,
      };

const mapStateToProps = combineSelectors({
  modelWorkingStateDenormalized,
  templatePriority,
  inCartQuantity,
  templateQuantity,
  theme,
  workingStateSubmissionLoading,
  modelSubmittedTotalWorkingStateCalculated,
  totalQuota,
});

export default compose(
  connect(
    mapStateToProps,
    {
      updateModelWorkingState,
    },
  ),
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['addToCartString'],
  }),
  withHandlers({ submitToCart }),
  addProps({ remainingQuota }),
  addProps({ disabledButton }),
  addProps({ buttonStyle, buttonTheming }),
);
